import $ from 'jquery'

// Returns the value of the named prop if it is of the provided type and/or
// constructor class. Otherwise, returns undefined. This is useful in cases
// where a prop may be unnexpectedly overriden. E.g. The action prop of a form
// which has an input named action, will contain the input element instead of
// the form action uri.
$.fn.getProp = function (propName, options) {
  const propVal = this.prop(propName)
  const type = options && options.type
  const klass = options && options.constructor
  if (type && typeof propVal !== type) {
    return
  }

  if (klass && propVal instanceof klass) {
    return
  }

  return propVal
}
